<template>
  <div class="text-red-500 text-xs font-medium">
    <slot />
  </div>
</template>
